export default "__VITE_ASSET__BUtu2Q_S__"